export default __webpack_public_path__ + "static/media/recast.ai.e76a074f.svg";